module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "form"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/fire.png")
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Burn it Down")]), _vm._v(" "), _c('p', [_vm._v("Track your daily burnt points.")]), _vm._v(" "), _c('form', {
    on: {
      "submit": _vm.submitData
    }
  }, [_c('div', {
    staticClass: "inputs"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "days"
    }
  }, [_vm._v("Days in Sprint")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.days),
      expression: "days"
    }],
    attrs: {
      "name": "days",
      "placeholder": "e.g 10",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.days)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.days = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "points"
    }
  }, [_vm._v("Planned points")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.points),
      expression: "points"
    }],
    attrs: {
      "name": "points",
      "placeholder": "e.g 50"
    },
    domProps: {
      "value": (_vm.points)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.points = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    attrs: {
      "disabled": !_vm.days || !_vm.points,
      "type": "submit"
    }
  }, [_vm._v("Go!")])])]), _vm._v(" "), _c('link-to', {
    attrs: {
      "href": "#/sprints"
    }
  }, [_vm._v("Show completed sprints")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b68be32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 545
// module chunks = 1